import { env } from '@/env';
import type { MemberPeriodQuotaContentDto } from '@/models/interface/memberPlan';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = env.apiBaseUrlNoVersion;

export class MemberPlanService extends ApiFactory {
  constructor() {
    super(baseUrl);
  }

  /**
   * 取得會員本期額度資訊 (樂享聆學班)
   * @returns 本期使用額度、剩餘次數、重置日等資訊
   */
  getPeriodQuota(): Promise<ApiDataResponse<MemberPeriodQuotaContentDto>> {
    return super.get('v2/MemberPlan/period-quota');
  }
}
